import React from 'react';
import { AssetImage } from './AssetImage';
import { Asset } from '@/types/models/assets.types';
import { ComponentSelector } from './ComponentSelector';

interface AssetStudioSidePaneProps {
  asset?: Asset;
  isLoading: boolean;
  components: any[];
  current_components: any[];
  additionalCounters: any;
}

export const AssetStudioSidePane = ({
  asset,
  isLoading,
  components,
  current_components,
  additionalCounters,
}: AssetStudioSidePaneProps) => {
  return (
    <div className="flex flex-col h-full gap-2 w-full">
      <div className="h-[70%] w-full max-h-[70%] overflow-hidden">
        <ComponentSelector
          asset={asset}
          components={components}
          isLoading={isLoading}
          currentComponents={current_components}
          additionalCounters={additionalCounters}
        />
      </div>
      <div className="h-[30%] w-full">
        <AssetImage asset={asset} isLoading={isLoading} />
      </div>
    </div>
  );
};
